import { useState } from 'react';
import { applyTheme, readThemeChoice, storeThemeChoice, THEME_OPTIONS, type ThemeChoice } from '../lib/theme';

/**
 * Seletor de tema: sistema, claro, escuro (RNF15).
 *
 * Um grupo de tres botoes de radio estilizados, e nao um interruptor de dois
 * estados: "seguir o sistema" e a opcao que a maioria quer e um toggle a
 * esconderia. O texto acompanha o icone -- icone sozinho de sol e lua nao e
 * obvio para todo mundo.
 */
export function ThemeToggle(): JSX.Element {
  const [choice, setChoice] = useState<ThemeChoice>(() => readThemeChoice());

  const select = (next: ThemeChoice): void => {
    setChoice(next);
    applyTheme(next);
    storeThemeChoice(next);
  };

  return (
    <div role="radiogroup" aria-label="Tema da interface" className="inline-flex rounded-lg border border-line bg-surface p-0.5 shadow-soft">
      {THEME_OPTIONS.map((option) => {
        const active = option.value === choice;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => select(option.value)}
            title={option.label}
            className={`grid h-8 w-8 place-items-center rounded-md transition-colors ${
              active ? 'bg-elevated text-ink shadow-soft' : 'text-ink-subtle hover:text-ink'
            }`}
          >
            <span className="sr-only">{option.label}</span>
            <ThemeGlyph value={option.value} />
          </button>
        );
      })}
    </div>
  );
}

function ThemeGlyph({ value }: { readonly value: ThemeChoice }): JSX.Element {
  const common = {
    viewBox: '0 0 24 24',
    className: 'h-4 w-4',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.7,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
    focusable: 'false' as const,
  };
  if (value === 'light') {
    return (
      <svg {...common}>
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4" />
      </svg>
    );
  }
  if (value === 'dark') {
    return (
      <svg {...common}>
        <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <rect x="3.5" y="4.5" width="17" height="12" rx="2" />
      <path d="M8.5 20h7M12 16.5V20" />
    </svg>
  );
}
